<template>
    <component :is="template">
        <div>
            <div class="tit-wrap tit-wrap--unberline">
                <h2 class="tit">캐시충전</h2>
            </div>

            <v-divider class="d-md-none" />
            <div class="py-20px pt-md-0px pb-md-40px text-center">
                <div class="tit tit--xs">
                    <b class="black--text">{{ me?.name }}</b
                    >님의 나누리 캐시
                </div>
                <div class="mb-3 mt-1">
                    <b class="tit tit--lg primary--text font-weight-bold">{{ parseInt(+me?.cash || 0).format() }}</b> 원
                </div>
                <v-row align="center" justify="center" class="row--x-small mt-20px mt-md-30px">
                    <v-col cols="auto">
                        <v-btn color="primary" outlined to="/mypage/cashes/give"><v-icon size="20" class="mr-2">mdi-gift</v-icon>선물하기</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="primary" outlined to="/mypage/cashes/gift"><v-icon size="20" class="mr-2">mdi-text-box-search</v-icon>선물내역</v-btn>
                    </v-col>
                </v-row>
            </div>
            <v-divider />

            <div class="py-10px py-md-16px">
                <v-row v-for="(item, index) in pins" :key="index" class="row--small">
                    <v-col cols="12" md="9">
                        <pno-field v-model="item.pno" outlined dense hide-details placeholder="5자리" />
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field v-model="item.result" outlined dense placeholder="충전결과" hide-details disabled background-color="grey lighten-3" />
                    </v-col>
                </v-row>
                <div class="page-text grey--text text--darken-4 text-right mt-10px">성공: {{ success }}개, 실패: {{ failed }}개</div>
            </div>
            <v-divider v-if="amount && !$vuetify.breakpoint.mobile" />
            <div v-if="amount && !$vuetify.breakpoint.mobile" class="py-10px py-md-16px">
                <v-row justify="center" class="font-size-14 font-size-md-16 grey--text text--darken-3 text-center">
                    <v-col>
                        <div class="d-inline-flex align-center font-size-14 line-height-1">
                            <span class="mr-8px">이전 캐시</span><b class="font-size-18 font-size-md-22">{{ parseInt(+me?.cash || 0).format() }}</b
                            ><span class="ml-2px">원</span>
                        </div>
                    </v-col>
                    <v-col cols="auto">+</v-col>
                    <v-col>
                        <div class="d-inline-flex align-center font-size-14 line-height-1">
                            <span class="mr-8px">충전 캐시</span><b class="font-size-18 font-size-md-22">{{ parseInt(amount).format() }}</b
                            ><span class="ml-2px">원</span>
                        </div>
                    </v-col>
                    <v-col cols="auto">=</v-col>
                    <v-col>
                        <div class="d-inline-flex align-center font-size-14 line-height-1">
                            <span class="mr-8px">충전 후 캐시</span><b class="font-size-18 font-size-md-22">{{ parseInt(me.cash + amount).format() }}</b
                            ><span class="ml-2px">원</span>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <v-divider v-if="amount && $vuetify.breakpoint.mobile" />
            <div v-if="amount && $vuetify.breakpoint.mobile" class="v-data-table v-data-table--sm theme--light v-data-table--mobile">
                <div class="v-data-table__wrapper">
                    <table>
                        <tbody>
                            <tr class="v-data-table__mobile-table-row">
                                <td class="v-data-table__mobile-row">
                                    <div class="v-data-table__mobile-row__header">이전 캐시</div>
                                    <div class="v-data-table__mobile-row__cell"><span>{{ parseInt(+me?.cash || 0).format() }}원</span></div>
                                </td>
                                <td class="v-data-table__mobile-row">
                                    <div class="v-data-table__mobile-row__header">충전 캐시</div>
                                    <div class="v-data-table__mobile-row__cell"><span>{{ parseInt(amount).format() }}원</span></div>
                                </td>
                                <td class="v-data-table__mobile-row">
                                    <div class="v-data-table__mobile-row__header">충전 후 캐시</div>
                                    <div class="v-data-table__mobile-row__cell"><span>{{ parseInt(me.cash + amount).format() }}원</span></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <v-divider />
            <div class="py-10px py-md-16px">
                <v-row class="row--small">
                    <v-col :cols="$vuetify.breakpoint.mobile ? '6' : 'auto'" v-if="!charged">
                        <v-btn width="100%" color="grey darken-2" dark @click="addField"><v-icon class="mr-2" size="20">mdi-plus</v-icon>입력란 추가</v-btn>
                    </v-col>
                    <v-col :cols="$vuetify.breakpoint.mobile ? '6' : 'auto'" v-if="!charged">
                        <v-btn width="100%" color="teal" dark @click="$refs.uploader.$refs.input.click()"><v-icon class="mr-2" size="20">mdi-microsoft-excel</v-icon>대량 업로드</v-btn>
                        <v-file-input ref="uploader" class="d-none" @change="(file) => upload(file)" />
                    </v-col>
                    <v-spacer />
                    <v-col :cols="$vuetify.breakpoint.mobile ? '6' : 'auto'">
                        <v-btn width="100%" color="blue" class="white--text" :disabled="!charged" @click="refresh"><v-icon class="mr-2" size="20">mdi-refresh</v-icon>새로고침</v-btn>
                    </v-col>
                    <v-col :cols="$vuetify.breakpoint.mobile ? '6' : 'auto'">
                        <v-btn width="100%" color="#328BCB" class="white--text" :disabled="charged" @click="charge"><v-icon class="mr-2" size="20">mdi-plus-circle-multiple-outline</v-icon>충전하기</v-btn>
                    </v-col>
                </v-row>
            </div>
            <div class="page-text line-height-13 mt-4px mt-md-0">나누리 상품권은 나누리 캐시로 충전하여 도서 및 백화점 상품권, 구글 기프트 코드, 커피 등 다양한 상품으로 교환 하실 수 있습니다.</div>
        </div>

        <div class="mt-40px">
            <div class="mb-20px mb-md-30px text-center">
                <h3 class="font-size-20 font-size-md-24 line-height-1">안내사항</h3>
            </div>

            <v-row justify="center" class="row-cols-lg-5">
                <v-col cols="6" sm="4" md="3">
                    <div class="d-flex h-66px mb-16px mb-md-24px">
                        <v-img max-width="102" :aspect-ratio="102 / 32" src="/images/mypage/charge-icon.png" class="mt-auto mx-auto" />
                    </div>
                    <div class="page-text text-center">PIN 번호 입력</div>
                    <v-divider class="w-20px my-10px mx-auto my-md-14px" style="border-color:#1C2A7F;" />
                    <p class="page-text page-text--small line-height-13 text-center text-md-left">20자리 상품권 PIN 번호를 입력하여 충전하실 수 있습니다.</p>
                </v-col>
                <v-col cols="6" sm="4" md="3">
                    <div class="d-flex h-66px mb-16px mb-md-24px">
                        <v-img max-width="70" :aspect-ratio="70 / 52" src="/images/mypage/charge-icon2.png" class="mt-auto mx-auto" />
                    </div>
                    <div class="page-text text-center">ID 제한</div>
                    <v-divider class="w-20px my-10px mx-auto my-md-14px" style="border-color:#1C2A7F;" />
                    <p class="page-text page-text--small line-height-13 text-center text-md-left">상품권 PIN 번호를 10회 이상 잘못 입력 시, ID 로그아웃 및 차단 상태로 변경됩니다.</p>
                </v-col>
                <v-col cols="6" sm="4" md="3">
                    <div class="d-flex h-66px mb-16px mb-md-24px">
                        <v-img max-width="50" :aspect-ratio="50 / 50" src="/images/mypage/charge-icon3.png" class="mt-auto mx-auto" />
                    </div>
                    <div class="page-text text-center">불법 이용 금지</div>
                    <v-divider class="w-20px my-10px mx-auto my-md-14px" style="border-color:#1C2A7F;" />
                    <p class="page-text page-text--small line-height-13 text-center text-md-left">불법적인 방법으로 충전, 도용 시 법적 제재를 받습니다.</p>
                </v-col>
                <v-col cols="6" sm="4" md="3">
                    <div class="d-flex h-66px mb-16px mb-md-24px">
                        <v-img max-width="64" :aspect-ratio="64 / 66" src="/images/mypage/charge-icon4.png" class="mt-auto mx-auto" />
                    </div>
                    <div class="page-text text-center">캐시 충전</div>
                    <v-divider class="w-20px my-10px mx-auto my-md-14px" style="border-color:#1C2A7F;" />
                    <p class="page-text page-text--small line-height-13 text-center text-md-left">상품권 PIN 번호 입력 후 캐시 충전 시 취소가 불가 합니다.</p>
                </v-col>
                <v-col cols="6" sm="4" md="3">
                    <div class="d-flex h-66px mb-16px mb-md-24px">
                        <v-img max-width="60" :aspect-ratio="60 / 46" src="/images/mypage/charge-icon5.png" class="mt-auto mx-auto" />
                    </div>
                    <div class="page-text text-center">유효기간</div>
                    <v-divider class="w-20px my-10px mx-auto my-md-14px" style="border-color:#1C2A7F;" />
                    <p class="page-text page-text--small line-height-13 text-center text-md-left">유효기간은 발행일로부터 5년</p>
                </v-col>
            </v-row>
        </div>

        <div class="mt-40px mt-md-60px">
            <div class="mb-20px text-center">
                <h3 class="font-size-20 font-size-md-24 line-height-1">대량 업로드 방법</h3>
            </div>

            <div class="text-center">
                <v-btn color="#40C2AB" outlined @click="sampleDownload"><v-icon size="20" class="mr-8px">
                    mdi-microsoft-excel</v-icon><span class="font-size-14 font-weight-regular">샘플다운로드</span>
                </v-btn>
                <p class="font-size-12 grey--text text--darken-1 mt-8px">*대량 업로드는 PC에서만 가능합니다.</p>
            </div>
        </div>

        <div class="mt-40px mt-md-60px">
            <v-row justify="center">
                <v-col cols="12" sm="6" md="">
                    <v-row class="row--xx-small">
                        <v-col cols="auto"><v-img max-width="20" src="/images/icon/icon-1.svg"/></v-col>
                        <v-col>
                            <p class="page-text page-text--small line-height-13 min-h-lg-54px">위에 ‘샘플다운로드’ 버튼을 눌러 대량 업로드용 양식을 다운받습니다.</p>
                        </v-col>
                    </v-row>
                    <div class="mt-14px mt-md-20px">
                        <v-img max-width="156" :aspect-ratio="156 / 46" src="/images/mypage/charge-img.png" class="mx-auto" />
                    </div>
                </v-col>
                <v-col cols="12" sm="6" md="">
                    <v-row class="row--xx-small">
                        <v-col cols="auto"><v-img max-width="20" src="/images/icon/icon-2.svg"/></v-col>
                        <v-col>
                            <p class="page-text page-text--small line-height-13 min-h-lg-54px">도서교환권이 있는 첫번째 줄은 수정하지 않고 두번째 줄부터 핀을 입력합니다.</p>
                        </v-col>
                    </v-row>
                    <div class="mt-14px mt-md-20px">
                        <v-img :width="$vuetify.breakpoint.lgAndUp ? 206 : 'auto'" max-width="206" :aspect-ratio="206 / 106" src="/images/mypage/charge-img2.png" class="mx-auto" />
                    </div>
                </v-col>
                <v-col cols="12" sm="6" md="">
                    <v-row class="row--xx-small">
                        <v-col cols="auto"><v-img max-width="20" src="/images/icon/icon-3.svg"/></v-col>
                        <v-col>
                            <p class="page-text page-text--small line-height-13 min-h-lg-54px">파일을 저장 후 위에 ‘대량 업로드’ 버튼을 눌러 저장한 파일을 업로드합니다.</p>
                        </v-col>
                    </v-row>
                    <div class="mt-14px mt-md-20px">
                        <v-img max-width="156" :aspect-ratio="156 / 46" src="/images/mypage/charge-img3.png" class="mx-auto" />
                    </div>
                </v-col>
                <v-col cols="12" sm="6" md="">
                    <v-row class="row--xx-small">
                        <v-col cols="auto"><v-img max-width="20" src="/images/icon/icon-4.svg"/></v-col>
                        <v-col>
                            <p class="page-text page-text--small line-height-13 min-h-lg-54px">파일 업로드 후 ‘충전하기’ 버튼을 누르면 완료됩니다.</p>
                        </v-col>
                    </v-row>
                    <div class="mt-14px mt-md-20px">
                        <v-img max-width="156" :aspect-ratio="156 / 46" src="/images/mypage/charge-img4.png" class="mx-auto" />
                    </div>
                </v-col>
            </v-row>
        </div>

        <div class="mt-40px mt-md-60px">
            <v-row class="row--x-small">
                <!-- <v-col cols="12">
                    <a href="https://front.wemakeprice.com/product/1959857065?search_keyword=%25EB%2582%2598%25EB%2588%2584%25EB%25A6%25AC%2520%25EC%2583%2581%25ED%2592%2588%25EA%25B6%258C&_service=5&_no=1" target="_blank">
                        <v-img :aspect-ratio="850 / 260" src="/images/mypage/charge-banner.jpg" />
                    </a>
                </v-col>
                <v-col cols="12">
                    <a href="http://www.tmon.co.kr/deal/13248962078" target="_blank">
                        <v-img :aspect-ratio="850 / 260" src="/images/mypage/charge-banner2.jpg" />
                    </a>
                </v-col> -->
                <v-col cols="12">
                    <v-row :no-gutters="$vuetify.breakpoint.mdAndUp ? true : false" class="row--x-small">
                        <!-- <v-col cols="12" md="6"> -->
                            <!-- <v-img :aspect-ratio="425 / 230" src="/images/mypage/charge-banner3.jpg" /> -->
                            <!-- <a href="https://play.google.com/store/apps/details?id=kr.uxi.everyonesads" target="_blank" class="d-block banner-link banner-link1"></a> -->
                            <!-- <a href="" onclick="alert('준비중입니다');return false;" class="d-block banner-link banner-link2"></a> -->
                        <!-- </v-col> -->
                        <v-col cols="12">
                            <a href="/gshop/brand">
                                <v-img :aspect-ratio="816 / 230" src="/images/mypage/charge-banner4.jpg" />
                            </a>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </component>
</template>
<script>
import api from "@/api";
import XLSX from "xlsx";
import download from "downloadjs";
import { mdiGift, mdiRefresh, mdiTextBoxSearch, mdiMicrosoftExcel, mdiPlusCircleMultipleOutline, mdiHelpCircleOutline } from "@mdi/js";
import PnoField from "@/components/client/pin/pno-field.vue";
export default {
    components: {
        PnoField,
    },
    data() {
        return {
            mdiGift,
            mdiRefresh,
            mdiTextBoxSearch,
            mdiMicrosoftExcel,
            mdiHelpCircleOutline,
            mdiPlusCircleMultipleOutline,

            me: null,

            pins: [{ pno: null, result: null }],
            pinsHeaders: [
                { text: "핀번호", value: "pno", align: "center" },
                { text: "충전결과", value: "result", align: "center", width: 200 },
            ],

            amount: 0,
            success: 0,
            failed: 0,
            charged: false,
        };
    },
    mounted() {
        if (this.logoff) {
            this.$router.push(`/login`);
            return;
        }

        this.init();
    },
    methods: {
        download,
        async init() {
            let { me } = await api.v1.me.profile.get();
            this.me = me;
        },
        addField() {
            this.pins.push({ pno: null, result: null });
        },
        async charge() {
            if (!this.pins.find((pin) => !!pin.pno)) {
                alert("핀번호를 입력해주세요");
                return;
            }

            for (var pin of this.pins) {
                if (!pin.pno) continue;
                let { success, message, amount } = await api.v1.me.cashes.charge(pin);
                if (message === "캐시 충전 10회 실패로 인하여 ID가 차단되었습니다. \n고객센터로 문의주시길 바랍니다. \n[1800-9510]") {
                    alert(message);
                    this.$store.dispatch("logout");
                }

                if (amount) {
                    this.amount = this.amount + amount;
                }

                this.$set(pin, "result", message);
                success ? this.success++ : this.failed++;
            }
            setTimeout(() => {
                if (this.success) {
                    alert("충전되었습니다");
                    // this.init();
                }
            }, 500);
            this.charged = true;
        },
        refresh() {
            this.pins = [];
            this.$nextTick((_) => (this.pins = [{ pno: null, result: null }]));
            this.charged = false;
            this.success = 0;
            this.failed = 0;
            this.amount = 0;
            this.init();
        },
        upload(file) {
            if (!file) return;
            let fileName = file.name.split(".");
            if (fileName[fileName.length - 1] !== "xlsx") {
                return alert("엑셀파일만 가능합니다");
            }
            let reader = new FileReader();
            reader.onload = () => {
                var workSheets = [];
                var workBook = XLSX.read(reader.result, { type: "binary" });
                workBook.SheetNames.forEach((sheetName) => {
                    let sheet = XLSX.utils.sheet_to_json(workBook.Sheets[sheetName]);
                    workSheets.push(sheet);
                });

                this.pins = [];
                let index = 0;
                for (let row of workSheets[0]) {
                    if (row["도서교환권"].length !== 20) {
                        alert("핀번호를 확인해주세요");
                        this.$router.go();
                    }
                    let pno = row["도서교환권"];
                    this.$set(this.pins, index++, { pno: pno?.replace(/[^0-9A-Z]/g, ""), result: null });
                }
            };
            reader.readAsBinaryString(file);
        },
        sampleDownload() {
            api.getResource("/assets/sample.xlsx").then((file) => download(file, "샘플다운로드.xlsx"));
        },
    },
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
        logoff() {
            return !this.accessToken;
        },
        template() {
            return () => import(`@/templates/${this.$theme.pages.mypage}`);
        },
    },
};
</script>

<style scoped>
.banner-link-wrap {
    position: relative;
}
.banner-link {
    position: absolute;
    width: 50%;
    height: 30%;
    z-index: 2;
    bottom: 0;
}
.banner-link1 {
    left: 0;
}
.banner-link2 {
    right: 0;
}
@media (min-width: 960px) {
    .banner-link {
        width: 189px;
        height: 44px;
        bottom: 15px;
    }
    .banner-link1 {
        left: 31px;
    }
    .banner-link2 {
        right: 31px;
    }
}
</style>
